import axios from 'axios'

import {
  SYNERISE_API_RESPONSE_TIMEOUT,
  SYNERISE_API_URL
} from 'lib/synerise/config'

export const syneriseClientApi = axios.create({
  baseURL: SYNERISE_API_URL,
  timeout: SYNERISE_API_RESPONSE_TIMEOUT
})
